import React, { useCallback, useEffect } from 'react'
import { TableV2Body, TableV2Container, TableV2Header, TableV2HeaderTd, TableV2HeaderTitle } from './index.styled'
import TableV2RowSkeleton from './skeleton'
import { InView, useInView } from 'react-intersection-observer'
import { TableLoader } from '../../style/table/loader/index.styled'
import { getGridTemplateColumns } from './helper'

const PER_LOAD = 5

const CustomTableV2 = React.memo(({
	headers = [], onLoad, totalLength = 0, currentLength = totalLength, perLoad = PER_LOAD,
	id, isLoaded = false, children, emptyRow = null, stickyHeader = false,
	columns = [],
}) => {
	const { ref, inView } = useInView({
		threshold: 0,
	})
	const isEmptyTable = isLoaded && !currentLength
	const gridTemplateColumns = getGridTemplateColumns({ headers, columns })
	const headerLayout = stickyHeader ? 'lf-sticky' : ''

	const loadTable = useCallback(() => {
		if (onLoad) onLoad(Math.ceil(currentLength / perLoad), perLoad)
	}, [currentLength, perLoad, onLoad])

	useEffect(() => {
		if ((totalLength === currentLength && currentLength === 0) || (inView && totalLength > currentLength)) {
			loadTable()
		}
	}, [totalLength, currentLength]) // eslint-disable-line react-hooks/exhaustive-deps

	const handleInViewChange = useCallback((inView) => {
		if (inView && totalLength > currentLength) {
			loadTable()
		}
	}, [totalLength, currentLength, loadTable])

	return (
		<TableV2Container id={id}>
			<TableV2Header columns={gridTemplateColumns} className={headerLayout}>
				{headers.map((header, i) => (
					<TableV2HeaderTd key={i} className={header.className} data-testid={'table-v2-header-' + header.title} onClick={header.onClick}>
						<TableV2HeaderTitle className={header.className}>{header.title}</TableV2HeaderTitle>
						{header.image && header.image}
					</TableV2HeaderTd>
				))}
			</TableV2Header>
			<TableV2Body>
				{!isLoaded &&
					(Array(4)).fill().map((el, index) =>
						<TableV2RowSkeleton key={'skeleton-' + index} headers={headers} columns={columns} />)}
				{isLoaded && currentLength > 0 && children}
				{isEmptyTable && emptyRow}
			</TableV2Body>
			<InView as={TableLoader} onChange={handleInViewChange} style={{ marginTop: 0 }}>
				<span id={`${id}-total-count`} style={{ opacity: 0 }} ref={ref}>{totalLength}</span>
			</InView>
		</TableV2Container>
	)
})

CustomTableV2.displayName = 'CustomTableV2'
export default CustomTableV2

